import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { attendanceCorrectionActions as actions, notificationActions } from '../actions';
import { attendanceCorrectionService } from '../services';


/* Apply Attendance Correction Sagas */
function* handleApplyAttendanceCorrectionRequest() {
    const action = yield take(actions.applyAttendanceCorrectionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(attendanceCorrectionService.applyAttendanceCorrection, dataParams);
        if (res.isError) {
            yield put(actions.applyAttendanceCorrectionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
            // yield put(notificationActions.notificationError({ message: res?.errorMessage, alertType: "error" }));
        } else {
            yield put(actions.applyAttendanceCorrectionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.applyAttendanceCorrectionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Attendance Correction Request Data Sagas */
function* handleGetAttendanceCorrectionRequestDataRequest() {
    const action = yield take(actions.getAttendanceCorrectionRequestDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(attendanceCorrectionService.getAttendanceCorrectionRequest, dataParams);
        if (res.isError) {
            yield put(actions.getAttendanceCorrectionRequestDataError(res));
        } else {
            yield put(actions.getAttendanceCorrectionRequestDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAttendanceCorrectionRequestDataError());
    }
}

/* Approve Reject Attendance Correction Sagas */
function* handleApproveRejectAttendanceCorrectionRequest() {
    const action = yield take(actions.approveRejectAttendanceCorrectionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(attendanceCorrectionService.approveRejectAttendanceCorrection, dataParams);
        if (res.isError) {
            yield put(actions.approveRejectAttendanceCorrectionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.approveRejectAttendanceCorrectionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.approveRejectAttendanceCorrectionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Attendance Correction Approval Sagas */
function* handleGetAttendanceCorrectionApprovalRequest() {
    const action = yield take(actions.getAttendanceCorrectionApprovalRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(attendanceCorrectionService.getAttendanceCorrectionApproval, dataParams);
        if (res.isError) {
            yield put(actions.getAttendanceCorrectionApprovalError(res));
        } else {
            yield put(actions.getAttendanceCorrectionApprovalSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAttendanceCorrectionApprovalError());
    }
}

/* Get Attendance Correction Approval Sagas */
function* handleUpdateAttendanceLogRequest() {
    const action = yield take(actions.updateAttendanceLogRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(attendanceCorrectionService.updateAttendanceLog, dataParams);
        if (res.isError) {
            yield put(actions.updateAttendanceLogError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateAttendanceLogSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateAttendanceLogError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Attendance Logs Sagas */
function* handleGetAttendanceLogsRequest() {
    const action = yield take(actions.getAttendanceLogsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(attendanceCorrectionService.getAttendanceLogs, dataParams);
        if (res.isError) {
            yield put(actions.getAttendanceLogsError(res));
        } else {
            yield put(actions.getAttendanceLogsSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAttendanceLogsError());
    }
}

/* Get Attendance Logs Sagas */
function* handleAttendanceCorrectionLogsRequest() {
    const action = yield take(actions.attendanceCorrectionLogsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(attendanceCorrectionService.attendanceCorrectionLogs, dataParams);
        if (res.isError) {
            yield put(actions.attendanceCorrectionLogsError(res));
        } else {
            yield put(actions.attendanceCorrectionLogsSuccess(res));
        }
    } catch (error) {
        yield put(actions.attendanceCorrectionLogsError());
    }
}
/*-----------Watchers-------------*/
function* handleApplyAttendanceCorrectionWatcher() {
    yield takeEvery(
        actions.applyAttendanceCorrectionRequest,
        handleApplyAttendanceCorrectionRequest,
    );
}

function* handleGetAttendanceCorrectionRequestDataWatcher() {
    yield takeEvery(
        actions.getAttendanceCorrectionRequestDataRequest,
        handleGetAttendanceCorrectionRequestDataRequest,
    );
}

function* handleApproveRejectAttendanceCorrectionWatcher() {
    yield takeEvery(
        actions.approveRejectAttendanceCorrectionRequest,
        handleApproveRejectAttendanceCorrectionRequest,
    );
}

function* handleGetAttendanceCorrectionApprovalWatcher() {
    yield takeEvery(
        actions.getAttendanceCorrectionApprovalRequest,
        handleGetAttendanceCorrectionApprovalRequest,
    );
}

function* handleUpdateAttendanceLogWatcher() {
    yield takeEvery(
        actions.updateAttendanceLogRequest,
        handleUpdateAttendanceLogRequest,
    );
}

function* handleGetAttendanceLogsWatcher() {
    yield takeEvery(
        actions.getAttendanceLogsRequest,
        handleGetAttendanceLogsRequest,
    );
}


function* handleAttendanceCorrectionLogsWatcher() {
    yield takeEvery(
        actions.attendanceCorrectionLogsRequest,
        handleAttendanceCorrectionLogsRequest,
    );
}
function* rootAttendanceCorrectionSaga() {
    yield all([
        handleApplyAttendanceCorrectionRequest(),
        handleApplyAttendanceCorrectionWatcher(),

        handleGetAttendanceCorrectionRequestDataRequest(),
        handleGetAttendanceCorrectionRequestDataWatcher(),

        handleApproveRejectAttendanceCorrectionRequest(),
        handleApproveRejectAttendanceCorrectionWatcher(),

        handleGetAttendanceCorrectionApprovalRequest(),
        handleGetAttendanceCorrectionApprovalWatcher(),

        handleUpdateAttendanceLogRequest(),
        handleUpdateAttendanceLogWatcher(),

        handleGetAttendanceLogsRequest(),
        handleGetAttendanceLogsWatcher(),

        handleAttendanceCorrectionLogsRequest(),
        handleAttendanceCorrectionLogsWatcher(),

    ]);
}

export default rootAttendanceCorrectionSaga;
